"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _shared = require("../shared");

var _shared2 = _interopRequireDefault(require("./shared"));

var _variants = require("./variants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Span = _styledComponents["default"].span.withConfig({
  shouldForwardProp: _shared.shouldForwardProp
}).withConfig({
  displayName: "span__Span",
  componentId: "sc-1tgddys-0"
})(["", ";", ";"], _shared2["default"], _variants.bodyVariants);

var _default = Span;
exports["default"] = _default;